/* Kkumi stamp card — the ONE renderer for the punch-card tracker.
 *
 * Every surface that shows a member's stamp card draws it through here: the
 * Club page card (kkumi-club.js), the account Kkumi Club tab
 * (kkumi-account-rewards.js), the cart points module
 * (section-kkumi-cart-points.js) and the Club landing earn panel
 * (kkumi-club-landing.js).
 * Styles: the `.kk-stamps` / `.kk-stamp` atom in assets/kkumi-tokens.css.
 *
 * Usage:
 *   KKStamps.draw(host, { count: 3, per_card: 5 })            // 3 ✦ + 2 empties
 *   KKStamps.draw(host, p, { next: 1, label: 'Stamp card' })   // + 1 previewed
 *   KKStamps.vars(p, { next: 1 })   // { count, total, left, reward, next } for copy
 *
 * `p` is the rewards app's punch object (/card or /program): count, per_card,
 * reward_label. `next` previews stamps a purchase is about to add (accent
 * outline, faint ✦). Spans, not divs, so Dawn's div:empty rule can never hide
 * an unfilled stamp. per_card is server-clamped (1..50).
 */
(function () {
  'use strict';
  if (window.KKStamps) return;

  function nums(p, o) {
    var total = Math.max(0, Number(p && p.per_card) || 0);
    var count = Math.min(Math.max(0, Number(p && p.count) || 0), total);
    var next = Math.min(Math.max(0, Number(o && o.next) || 0), total - count);
    return { total: total, count: count, next: next };
  }

  window.KKStamps = {
    draw: function (host, p, o) {
      if (!host) return;
      o = o || {};
      var n = nums(p, o);
      var cls = 'kk-stamp' + (o.cls ? ' ' + o.cls : '');
      host.replaceChildren();
      for (var i = 0; i < n.total; i++) {
        var st = document.createElement('span');
        var on = i < n.count, nx = !on && i < n.count + n.next;
        st.className = cls + (on ? ' is-on' : '') + (nx ? ' is-next' : '');
        st.textContent = on || nx ? '✦' : '';
        host.appendChild(st);
      }
      if (o.label != null) {
        host.setAttribute('role', 'img');
        host.setAttribute('aria-label', o.label);
      }
    },
    // Values for the surface's own copy template ({count} / [count] styles
    // differ per section, so each host fills its own tokens).
    vars: function (p, o) {
      var n = nums(p, o);
      var after = n.count + n.next;
      return { count: n.count, total: n.total, next: after, left: Math.max(0, n.total - after), reward: (p && p.reward_label) || '' };
    }
  };
})();
